module.exports = __webpack_public_path__ + "img/logo.7d55d02a.svg";